module.exports = __webpack_public_path__ + "static/img/value.56b88a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/value.png
// module id = mqvk
// module chunks = 1